import moment from "moment";
export default function(value) {
	return moment(value).format("MMMM Do YYYY, h:mm:ss a");
}
